/** Plain values, no SDK. Kept apart from firebase.ts so the client's preview
 *  page can read the API base without dragging Firestore into its bundle. */
export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

/** Stripe's publishable key, for paying on the page. Public by design. Empty
 *  and the page only ever offers Etsy. */
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? "";
